import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSparkle48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="sparkle">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 8C20.4621 8 20.864 8.31658 20.9722 8.76579L22.5621 15.3655C23.7275 20.2033 27.3734 24.0588 32.1385 25.4928L37.2882 27.0424C37.7107 27.1696 38 27.5587 38 28C38 28.4413 37.7107 28.8304 37.2882 28.9576L32.1385 30.5072C27.3734 31.9412 23.7275 35.7967 22.5621 40.6345L20.9722 47.2342C20.864 47.6834 20.4621 48 20 48C19.5379 48 19.136 47.6834 19.0278 47.2342L17.4379 40.6345C16.2725 35.7967 12.6266 31.9412 7.86153 30.5072L2.71184 28.9576C2.28926 28.8304 2 28.4413 2 28C2 27.5587 2.28926 27.1696 2.71184 27.0424L7.86153 25.4927C12.6266 24.0588 16.2725 20.2033 17.4379 15.3655L19.0278 8.76579C19.136 8.31658 19.5379 8 20 8ZM20 13.2697L19.3823 15.8339C18.0503 21.3628 13.8837 25.7691 8.43785 27.4079L6.47029 28L8.43785 28.5921C13.8837 30.2309 18.0503 34.6372 19.3823 40.1661L20 42.7303L20.6177 40.1661C21.9497 34.6372 26.1163 30.2309 31.5621 28.5921L33.5297 28L31.5622 27.4079C26.1163 25.7691 21.9497 21.3628 20.6177 15.8339L20 13.2697Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 0C37.4616 0 37.8632 0.315908 37.9719 0.764493L38.7994 4.1793C39.3855 6.59807 41.2118 8.52375 43.5962 9.23707L46.2866 10.042C46.71 10.1686 47 10.5581 47 11C47 11.4419 46.71 11.8314 46.2866 11.958L43.5962 12.7629C41.2118 13.4762 39.3855 15.4019 38.7994 17.8207L37.9719 21.2355C37.8632 21.6841 37.4616 22 37 22C36.5384 22 36.1368 21.6841 36.0281 21.2355L35.2006 17.8207C34.6145 15.4019 32.7882 13.4762 30.4038 12.7629L27.7134 11.958C27.29 11.8314 27 11.4419 27 11C27 10.5581 27.29 10.1686 27.7134 10.042L30.4038 9.23707C32.7882 8.52375 34.6145 6.59807 35.2006 4.1793L36.0281 0.764493C36.1368 0.315908 36.5384 0 37 0ZM37 5.1762C36.1683 7.88208 34.1086 10.0419 31.4426 11C34.1086 11.9581 36.1683 14.1179 37 16.8238C37.8317 14.1179 39.8914 11.9581 42.5574 11C39.8914 10.0419 37.8317 7.88208 37 5.1762Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconSparkle24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="sparkle">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0C12.4694 0 12.8756 0.326468 12.9766 0.784864L13.9049 4.99865C14.4369 7.41374 16.2037 9.36889 18.5528 10.1419L21.3126 11.0501C21.7228 11.1851 22 11.5682 22 12C22 12.4318 21.7228 12.8149 21.3126 12.9499L18.5528 13.8581C16.2037 14.6311 14.4369 16.5863 13.9049 19.0013L12.9766 23.2151C12.8756 23.6735 12.4694 24 12 24C11.5306 24 11.1244 23.6735 11.0234 23.2151L10.0951 19.0013C9.56311 16.5863 7.79625 14.6311 5.44719 13.8581L2.68741 12.9499C2.27721 12.8149 2 12.4318 2 12C2 11.5682 2.27721 11.1851 2.68741 11.0501L5.44718 10.1419C7.79625 9.36889 9.56311 7.41374 10.0951 4.99865L11.0234 0.784864C11.1244 0.326468 11.5306 0 12 0ZM12 5.63653C11.2725 8.60364 9.08739 11.002 6.19606 12C9.08739 12.998 11.2725 15.3964 12 18.3635C12.7275 15.3964 14.9126 12.998 17.8039 12C14.9126 11.002 12.7275 8.60364 12 5.63653Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconSparkle16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="sparkle">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C8.46565 0 8.86968 0.321402 8.97439 0.775127L9.70665 3.94806C9.96179 5.0536 10.7833 5.94137 11.8657 6.28139L14.2997 7.04596C14.7164 7.17688 15 7.56316 15 8C15 8.43684 14.7164 8.82312 14.2997 8.95404L11.8657 9.71861C10.7833 10.0586 9.96179 10.9464 9.70665 12.0519L8.97439 15.2249C8.86968 15.6786 8.46565 16 8 16C7.53435 16 7.13032 15.6786 7.02561 15.2249L6.29335 12.0519C6.03821 10.9464 5.21674 10.0586 4.1343 9.71861L1.70031 8.95404C1.28355 8.82312 1 8.43684 1 8C1 7.56316 1.28355 7.17688 1.70031 7.04596L4.1343 6.28139C5.21674 5.94137 6.03821 5.0536 6.29335 3.94806L7.02561 0.775127C7.13032 0.321402 7.53435 0 8 0ZM8 5.16841C7.49102 6.43462 6.50108 7.45497 5.24247 8C6.50108 8.54503 7.49103 9.56538 8 10.8316C8.50898 9.56538 9.49892 8.54503 10.7575 8C9.49892 7.45497 8.50897 6.43462 8 5.16841Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
